import React, { useCallback } from "react";
import DynamicLinesDialog from "../../../components/DynamicLinesDialog";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { accountsmanagement } from "../../../config";
import { allAccountSubCategories, allTaxRates } from "../../../data/Axios/queries";

const base_url = accountsmanagement.uri;

export const CreditNoteDetailDialog = ({ open, onClose, creditNoteData, refetchData }) => {
    const loadAccountSubCategories = useCallback(async () => {
        const data = await graphqlQuery(allAccountSubCategories, base_url);
        return (data || []).filter((subCat) => [34, 37].includes(subCat.id));
    }, []);

    const loadTaxRates = useCallback(async () => {
        const data = await graphqlQuery(allTaxRates, base_url);
        return (data || []).filter((tax) => tax.taxTypeId === 1);
    }, []);

    const calculateVatAmount = useCallback((formValues, fieldOptions) => {
        const { amount, vatId } = formValues;
        const taxRates = fieldOptions.vatId || [];
        if (!amount || !vatId) return { vatAmount: 0 };
        const selectedTax = taxRates.find((tax) => tax.id === parseInt(vatId));
        if (!selectedTax) return { vatAmount: 0 };
        const vatAmount = (parseFloat(amount) * (selectedTax.rate / 100)).toFixed(2);
        return { vatAmount: parseFloat(vatAmount) };
    }, []);

    const formFields = [
        { name: "description", label: "Description", type: "text", required: true },
        { name: "accountSubCategoryId", label: "Account Subcategory", type: "select", required: true },
        { name: "amount", label: "Amount", type: "number", required: true, onChangeEffect: "calculateVat" },
        { name: "vatId", label: "VAT", type: "select", required: true, onChangeEffect: "calculateVat" },
        { name: "vatAmount", label: "VAT Amount", type: "number", disabled: true },
    ];

    const columns = [
        { field: "id", headerName: "ID", flex: 0.5 },
        { field: "description", headerName: "Description", flex: 2 },
        { field: "accountSubCategoryName", headerName: "Account Subcategory", flex: 1.2 },
        { field: "amount", headerName: "Amount", flex: 1, format: "currency" },
        { field: "vatAmount", headerName: "VAT Amount", flex: 1, format: "currency" },
    ];

    const queryConfig = {
        // Root query should be the API query name; modelName is the input object
        name: "allCreditNotesLinesByCreditId",
        modelName: "creditNotesLines",
        // We pass the parent credit note id using the `creditNoteId` field
        inputField: "creditNoteId",
        fields: [
            "id",
            "description",
            "accountSubCategoryId",
            "accountSubCategoryName",
            "amount",
            "vatId",
            "vatAmount",
            "isActive",
        ],
    };

    const mutationConfig = {
        create: "createCreditNotesLine",
        update: "updateCreditNotesLine",
        modelName: "creditNotesLines",
    };

    return (
        <DynamicLinesDialog
            open={open}
            onClose={onClose}
            title={`Credit Note Lines – ${creditNoteData?.documentNumber || ""}`}
            parentData={creditNoteData}
            parentIdField="creditNoteId"
            baseUrl={base_url}
            queryConfig={queryConfig}
            mutationConfig={mutationConfig}
            refetchData={refetchData}
            formFields={formFields}
            columns={columns}
            optionsLoaders={{ accountSubCategoryId: loadAccountSubCategories, vatId: loadTaxRates }}
            customCalculations={{ calculateVat: calculateVatAmount }}
            additionalMutationData={{ isActive: 1 }}
            readOnlyInfo={{ fields: [{ label: "Credit Note", getValue: () => creditNoteData?.documentNumber || "N/A" }] }}
            canAdd={true}
        />
    );
};

export default CreditNoteDetailDialog;
